import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

const InputFormat = forwardRef((props, ref) => {
  const { onChange, inputType, pricePrepend, skipSourceInfoCheck, ...restProps } = props

  return (
    <NumberFormat
      getInputRef={ref}
      onValueChange={(values, sourceInfo) => {
        if (skipSourceInfoCheck || sourceInfo?.event) {
          onChange({
            target: {
              name: props?.name,
              value: values?.value,
            },
            source: sourceInfo?.source,
          })
        }
      }}
      decimalScale={inputType === 'price' ? 2 : undefined}
      thousandSeparator
      isNumericString
      prefix={inputType === 'price' ? `${pricePrepend}` : undefined}
      suffix={inputType === 'percent' ? '%' : undefined}
      {...restProps}
    />
  )
})

InputFormat.propTypes = {
  name: PropTypes.string.isRequired,
  inputType: PropTypes.oneOf(['number', 'price', 'percent']), // .isRequired,
  onChange: PropTypes.func.isRequired,
  pricePrepend: PropTypes.string,
  skipSourceInfoCheck: PropTypes.bool,
}

InputFormat.defaultProps = {
  inputType: 'number',
  pricePrepend: '$',
  skipSourceInfoCheck: true,
}

export default InputFormat
